import React, {useEffect, useState} from "react";
import './SurveyTable.css';
import getBaseUrl from "../../helpers/http";
import {useTranslation} from "react-i18next";
import {toast, ToastContainer} from 'react-toastify';
import Table from "../../components/Table";
import Skeleton from "../../components/Skeleton";
import TreeMenuItem from "../../components/TreeMenuItem";
import {RiPhoneFindLine} from "react-icons/ri";
import Modal from 'react-modal';
import MetaDataTable from "../MetaDataTable";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root')
const SurveyTable = ({parentId = 10}) => {

    const {t, i18n} = useTranslation();
    const [surveyFetchError, setSurveyFetchError] = useState(-1);
    const [reportFetchError, setReportFetchError] = useState(-1);

    const [tableData, setTableData] = useState();

    const [mergedList, setMergedList] = useState();
    const [metaData, setMetaData] = useState();
    const [activeSurvey, setActiveSurvey] = useState(9);
    const [fileDownloading, setFileDownloading] = useState(0);

    const currentLang = i18n.language;

    const [modalIsOpen, setIsOpen] = useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
    }

    function closeModal() {
        setIsOpen(false);
    }

    const getSurveyData = async (id) => {
        setActiveSurvey(id);
        setReportFetchError(-1)
        try {
            const reportResponse = await fetch(getBaseUrl() + `survey/sublist?lang=${currentLang}&surveyid=${id}`, {
                method: 'POST'
            });

            const reportResult = await reportResponse.json();
            if (reportResult.success) {
                setTableData(reportResult.result)
                setMetaData(reportResult.metadata)
                setReportFetchError(0);
            } else {
                setReportFetchError(1);
                toast.error(reportResult.result)
            }
        } catch (error) {
            setReportFetchError(2)
            toast.error(t('surveyTable.bulletin.catchError'))
            console.log('error 1', error);
        }
    }

    const downloadFile = async (id, fileName, type) => {

        if (fileDownloading === 1)
            return

        if (fileDownloading !== 0) {
            setFileDownloading(0)
            return
        }

        setFileDownloading(1)
        try {
            const downloadResponse = await fetch(getBaseUrl() + `survey/data?lang=${currentLang}&id=${id}&type=${type}`, {
                method: 'POST'
            });

            if (downloadResponse.status === 200) {

                if (downloadResponse.headers.get('Content-Type').includes('application/json')) {

                    const chartResult = await downloadResponse.json();

                    if (!chartResult.success) {
                        toast.error(chartResult.result)
                        setFileDownloading(2)
                    }
                } else {
                    const fileBlob = await downloadResponse.blob();
                    type = (type === 'pdf') ? type : (fileBlob?.type === 'application/vnd.ms-excel' ? 'xls' : 'xlsx')
                    const url = window.URL.createObjectURL(fileBlob);
                    if (type === 'pdf') {
                        window.open(url, '_blank');
                    }
                    const a = document.createElement('a');
                    a.href = url;

                    a.download = `${fileName}.${type}`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);

                }
                setFileDownloading(0)
            } else {
                toast.error(t('surveyTable.errorCatch'))
                setFileDownloading(2)
            }
        } catch (error) {
            console.log(error)
            toast.error(t('surveyTable.errorCatch'))
        }
    };

    const mergeDataWithParentId = (data) => {

        const idToItemMap = new Map();
        data.forEach(item => {
            idToItemMap.set(item.ID, item);
        });

        const keysIterator = idToItemMap.keys();
        keysIterator.next(); // First key
        if (parentId === 40)
            keysIterator.next();
        const secondKey = keysIterator.next().value;
        setActiveSurvey(secondKey)

        const merged = data.reduce((result, item) => {
            const parentItem = idToItemMap.get(item.parent_id);
            if (parentItem) {
                if (!parentItem.children) {
                    parentItem.children = [];
                }
                parentItem.children.push(item);
            } else {
                result.push(item);
            }
            return result;
        }, []);

        return [secondKey, merged]
    }


    useEffect(() => {
        let mergedArr = [];
        const fetchData = async () => {
            setSurveyFetchError(-1)
            try {
                const surveyResponse = await fetch(getBaseUrl() + `survey/list?lang=${currentLang}&surveyid=${parentId}`, {
                    method: 'POST'
                });

                const surveyResult = await surveyResponse.json();
                if (surveyResult.success) {
                    mergedArr = mergeDataWithParentId(surveyResult.result)
                    setMergedList(mergedArr[1])
                    setSurveyFetchError(0);
                } else {
                    setSurveyFetchError(1);
                    toast.error(surveyResult.result)
                }
            } catch (error) {
                setSurveyFetchError(2);
                toast.error(t('surveyTable.errorCatch'))
                console.log('error 1', error);
            }

        };

        fetchData().then(
            async () => {
                setReportFetchError(-1)
                try {
                    const reportResponse = await fetch(getBaseUrl() + `survey/sublist?lang=${currentLang}&surveyid=${mergedArr[0]}`, {
                        method: 'POST'
                    });

                    const reportResult = await reportResponse.json();

                    if (reportResult.success) {
                        setTableData(reportResult.result)
                        setMetaData(reportResult.metadata)
                        setReportFetchError(0);
                    } else {
                        setReportFetchError(1);
                        toast.error(reportResult.result)
                    }
                } catch (error) {
                    setReportFetchError(2)
                    toast.error(t('surveyTable.errorCatch'))
                    console.log('error 1', error);
                }
            }
        );
    }, [currentLang, parentId, t]);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {surveyFetchError === 0 ?
                <div className={"container mx-auto grid grid-cols-1 md:grid-cols-4 gap-4 mt-14"}>
                    <div
                        className={"bg-white py-2 ps-5 pe-1 shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] rounded-md tree-menu"}>

                        {
                            mergedList?.length > 0 ?
                                <TreeMenuItem list={mergedList}
                                              getData={getSurveyData} activeSurveyId={activeSurvey} activeCollapse={parentId === 40 ? 'collapse2' : 'collapse1'}
                                />
                                : ''
                        }

                    </div>

                    <div
                        className={" bg-white h-fit p-5 md:col-span-3 shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] rounded-md overflow-x-auto"}>
                        {reportFetchError === 0 ? <>
                            <Table data={tableData} rowsPerPage={10} getFile={downloadFile}
                                   loading={fileDownloading}></Table>
                            {metaData?.length === 0 ? "" : <div className={"flex flex-row justify-end"}>
                                <button
                                    onClick={openModal}
                                    className="w-fit bg-[#FFB800] text-[#163578] font-bold text-sm py-2 px-4 rounded inline-flex items-center mb-2">
                                    <RiPhoneFindLine className={"h-5 w-5"}/>
                                    <span className={"px-2"}>{t("surveyTable.metaData")}</span>
                                </button>
                            </div>}
                        </> : <Skeleton type={"TableLoader"}/>
                        }
                    </div>
                    <Modal
                        isOpen={modalIsOpen}
                        onAfterOpen={afterOpenModal}
                        onRequestClose={closeModal}
                        style={customStyles}
                        contentLabel=""
                    >
                        <MetaDataTable data={metaData} ind={reportFetchError}/>
                    </Modal>
                </div>
                : <Skeleton type={"OtherMainLoader"}/>
            }
        </>
    )
};

export default SurveyTable;